module.exports = __webpack_public_path__ + "static/scale-model-of-adventure-island-in-tampa-florida-ff4f36783a1f2b3dcbd34bdff158e7ea.png";